var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legoText_cnt_about_siteContents_heb",class:_vm.device === 'desktop' ? 'm-5' : 'm-3'},[_c('div',{staticClass:"lego-row",attrs:{"id":"cnt_about_siteContents_heb_0"}},[_c('div',{staticClass:"lego-col",staticStyle:{"width":"100%"},domProps:{"innerHTML":_vm._s(_vm.content)}})]),(_vm.isVIPPage)?_c('vip-reservation'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }